import React, { useEffect, useState } from "react";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import PrivateRouter from "./components/utils/PrivateRouter.js";
import Barra from "./Bar.js";
import Axios from "axios";
import auth from "./components/utils/Auth.js";
import Signup from "./components/signup/Signup.js";
import FloatingUploadButton from "./components/utils/FloatingUploadButton.js";
import UploadModal from "./components/utils/UploadModal.js";
import Login from "./components/login/Login";

export default function App() {

	const [authState, setAuthState] = useState(auth.isAuthenticated());

	useEffect(() => {
		function updateAuthState() {
			setAuthState(auth.isAuthenticated());
		}
		
		auth.subscribe(updateAuthState);

		return () => {
			auth.unsubscribe(updateAuthState);
		};
	}, []);

	const [uploadModalOpen, setUploadModalOpen] = useState(false);

	const handleUploadClick = () => {
		setUploadModalOpen(true);
	};

	const handleCloseUploadModal = () => {
		setUploadModalOpen(false);
	};

	const cargarToken = () => {
		Axios.interceptors.response.use((response) => {
			return response
		}, function (error) {
			const originalRequest = error.config;
			if ((error.response.status === 401) && !originalRequest._retry) {
				originalRequest._retry = true;
				var stored = localStorage.getItem("auth");
				if (stored !== null) {
					localStorage.setItem("auth", null)
					var oldAuth = JSON.parse(stored);
					const params = new URLSearchParams();
					params.append("email", oldAuth.credentials.email);
					params.append("password", oldAuth.credentials.password);
					return Axios.post(process.env.REACT_APP_BASE_URL + "/authentication", params, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
						.then(response => {
							if (response.status === 200) {
								Axios.defaults.headers.common["Authorization"] = "Bearer " + response.data;
								auth.login(oldAuth.credentials, response.data);
								localStorage.setItem("auth", JSON.stringify(auth));
								originalRequest.headers.Authorization = "Bearer " + response.data;
								return Axios(originalRequest);
							}
						});
				}
			}
		});

		let user = JSON.parse(localStorage.getItem("auth"));
		if (user != null && user.authenticated) {
			Axios.defaults.headers.common["Authorization"] = "Bearer " + user.token;
		}
	};

	cargarToken();

	return (
		<div className="app-routes">
			<BrowserRouter basename={'/'}>
				<Switch>
					<Route exact path="/login" component={Login} />
					<Route exact path="/signup" component={Signup} />
					<PrivateRouter path="/" component={Barra} />
					{!authState && <Redirect to="/login" />}
				</Switch>
			</BrowserRouter>
			{
				authState && auth.hasRole('STUDENT') && (
					<>
						<FloatingUploadButton onClick={handleUploadClick} />
						<UploadModal
							open={uploadModalOpen}
							onClose={handleCloseUploadModal}
						/>
					</>
				)
			}
		</div>
	);
}
